import { Grid } from '@mui/material';
import styled from 'styled-components';

const LoadingPage = styled(Grid)(() => ({
    height: '100svh',
    justifyContent: 'center',
    alignContent: 'center',
}));

export default LoadingPage;
